/*
 * @Author: LiuChuanQi
 * @Date: 2022-12-01 10:57:49
 * @LastEditTime: 2023-02-22 18:24:01
 * @LastEditors: LiuChuanQi
 * @Description: 登录模块接口封装
 * @FilePath: \speedtest-bigdata-v2\src\api\login.js
 *
 */
import request from '@/utils/request'
import qs from 'qs'
//获取登录短信
export const getIdentifyingCode = function ({ apiVersion, phone,randStr,ticket }) {
  return new Promise((resolve, reject) => {
    request.get(`/${apiVersion}/login/sms/phone/${phone}`,{
      params: { randStr,ticket }
    }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//短信验证码登录
export const messageLogin = function (data) {
  return new Promise((resolve, reject) => {
    request.post(`/v1/login`, data, { headers: { 'Content-Type': 'application/json' } }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//账号密码登录
export const passwordLogin = function (data) {
  return new Promise((resolve, reject) => {
    request.post(`/v1/login`, data, { headers: { 'Content-Type': 'application/json' } }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//注册接口验证码
export const getRegisterCode = function ({ apiVersion, phone,ticket, randStr }) {
  return new Promise((resolve, reject) => {
    request.get(`/${apiVersion}/user/register-sms`, {
      params: { phone,ticket, randStr }
    }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//注册接口
export const register = function ({ apiVersion, data }) {
  return new Promise((resolve, reject) => {
    request.post(`/${apiVersion}/user`, data).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}

//找回密码 手机验证码调用
export const getBackCode = function ({ apiVersion, phone,ticket, randStr }) {
  return new Promise((resolve, reject) => {
    request.get(`/${apiVersion}/user/password/change-sms`, {
      params: { phone,ticket, randStr }
    }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//修改密码
export const resetPassword = function ({ apiVersion, data }) {
  console.log(data)
  return new Promise((resolve, reject) => {
    request.put(`/${apiVersion}/user/password`,
      data, { headers: { 'Content-Type': 'application/json' } }
    ).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//获取个人中心的接口
export const getUserInfor = function ({ apiVersion, id }) {
  return new Promise((resolve, reject) => {
    request.get(`/${apiVersion}/user/${id}`).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//获取修改手机号的验证码
export const getSetPhoneCode = function ({ apiVersion, phone,ticket, randStr }) {
  return new Promise((resolve, reject) => {
    request.get(`/${apiVersion}/user/phone/verification-code`, {
      params: { phone,randStr,ticket }
    }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//修改绑定手机
export const resetPhone = function ({ apiVersion, data }) {
  return new Promise((resolve, reject) => {
    request.put(`/${apiVersion}/user/phone`,
      data, { headers: { 'Content-Type': 'application/json' } }
    ).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//新增邮箱
export const addEmail = function ({ apiVersion, email }) {
  return new Promise((resolve, reject) => {
    request.post(`/${apiVersion}/user/email/${email}`).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}

//获取新的邮箱校验
export const getSetEmailCode = function ({ apiVersion, email,ticket, randStr }) {
  return new Promise((resolve, reject) => {
    request.get(`/${apiVersion}/user/email/verification-code`, {
      params: {
        ticket,
        randStr,
        email,
      },
    }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//修改邮箱
export const resetEmail = function ({ apiVersion, data }) {
  return new Promise((resolve, reject) => {
    request.put(`/${apiVersion}/user/email`,
      data, { headers: { 'Content-Type': 'application/json' } }
    ).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}

//手机号注册第一次登录
export const phoneRegister = function ({ apiVersion, data }) {
  return new Promise((resolve, reject) => {
    request.post(`/${apiVersion}/user/initial`, data).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//注销账号
export const removeAccount = function ({ apiVersion, verificationCode, id }) {
  return new Promise((resolve, reject) => {
    request.delete(`/${apiVersion}/user/${id}`, {
      data: { verificationCode }
    }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//注销账号验证码
export const getCancelCode = function ({ apiVersion ,ticket, randStr}) {
  return new Promise((resolve, reject) => {
    request.get(`/${apiVersion}/user/delete-sms`, {
      params: { ticket, randStr }
    }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
//校验账号正确性
export const checkAccount = function ({ apiVersion, userName, phone, email }) {
  let params = {}
  if (userName) {
    params.userName = userName
  }
  if (phone) {
    params.phone = phone
  }
  if (email) {
    params.email = email
  }
  return new Promise((resolve, reject) => {
    request.get(`/${apiVersion}/user/inspection`, {
      params,
    }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}

//获取找回密码邮箱验证码
export const getBackEmailCode = function ({ apiVersion, email ,ticket, randStr}) {
  return new Promise((resolve, reject) => {
    request.get(`/${apiVersion}/user/password/change-email-sms`, {
      params: { email,ticket, randStr },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }
    }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}

//退出登录
export const loginOut = function ({ apiVersion }) {
  return new Promise((resolve, reject) => {
    request.delete(`/${apiVersion}/user/logout`).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}

/* 获取会员购买页信息 */
export const getPayInfor = function (apiVersion,type) {
  return new Promise((resolve, reject) => {
    request.post(`/${apiVersion}/order/type/${type}/member`,'', { headers: { 'Content-Type': 'application/json' } }).then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}

/**获取时间 */
export const getUpdateTime = function (apiVersion,type) {
  return new Promise((resolve, reject) => {
    request.get('/v1/month-limit').then((response) => {
      resolve(response)
    }, (err) => {
      reject(err)
    }).catch((err) => {
      reject(err)
    })
  })
}
